<template>
    <div v-if="icon || translation" class="preview">
        <h3>{{ $t('admin.preview') }}</h3>
        <div class="icon">
            <FaLightIcon :icon-name="icon" size="2x" />
        </div>
        <div>{{ translation }}</div>
        <div v-if="info" class="info">{{ info }}</div>
    </div>
</template>

<script lang="ts">
import { Component, Prop } from 'vue-property-decorator';
import FaLightIcon from '@/components/general/FaLightIcon.vue';
import Vue from 'vue';

@Component({
    components: {
        FaLightIcon,
    },
})
export default class IconPreview extends Vue {
    @Prop({ required: true }) readonly icon: string;
    @Prop({ required: true }) readonly translation: string;
    @Prop() readonly info?: string;
}
</script>
<style lang="scss" scoped>
.preview {
    display: grid;
    gap: 0.5rem;
    place-items: center;
    color: $sub-title-color;
    max-width: 7rem;
    margin-inline: auto;
    text-align: center;

    h3 {
        font-size: $font-size-medium;
    }
}

.icon {
    display: grid;
    place-items: center;
    width: 6rem;
    height: 6rem;
    background-color: $category-card-background-color;
    border: $card-border;
    box-shadow: $box-shadow-light;
    border-radius: $default-border-radius;
    color: $category-card-front-color;

    svg {
        width: 60%;
        height: 60%;
    }
}

.info {
    font-size: $font-size-small;
}
</style>
